import React, { useEffect, useState } from "react";
import Table from "../../components/table";
import { useNavigate } from "react-router-dom";
import Input from "../../components/input";
import FIlterSelect from "../../components/filter-select";
import {
    capitalizeFirstLetter,
    getStatusDiscountTextColor,
    getStatusColorDiscount
} from "../../utilz/function";

interface DiscountData {
    _id: string;
    name: string;
    discountValue: string;
    startDate: string;
    endDate: string;
    status: string;
}

interface UserTableProps {
  data: DiscountData[];
  selectedStatus?: string;
  handleStatusChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}

const DiscountTable: React.FC<UserTableProps> = ({data, selectedStatus}) => {
    const navigate = useNavigate();
    const [filteredData, setFilteredData] = useState<DiscountData[]>([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedType, setSelectedType] = useState("");

    const columns = [
        { header: "Name", accessor: "name" },
        { header: "Discount Value", accessor: "discountValue" },
        { header: "State Date", accessor: "startDate" },
        { header: "End Date", accessor: "endDate" },
        { header: "Status", accessor: "status" },
        { header: "Actions", accessor: "_id" },
    ];

    const handleUserClick = (_id: string) => {
        navigate(`/dashboard/discount/${_id}`);
    };

    useEffect(() => {
        const filtered = data?.filter((discount) => {
          const statusMatch =
            !selectedStatus || discount?.status === selectedStatus;
    
          const searchMatch =
            !searchQuery ||
            discount?.name
              ?.toLowerCase()
              .includes(searchQuery?.toLowerCase())
          const discountMatch = !selectedType || discount?.status === selectedType;
    
          return statusMatch && searchMatch && discountMatch;
        });
        setFilteredData(filtered);
    }, [data, selectedStatus, searchQuery, selectedType]);

    const combinedData = filteredData?.map((discount) => ({
        ...discount,
        contact: (
            <div>
                <div>{capitalizeFirstLetter(discount?.name) || "N/A"}</div>
            </div>
        ),
        name: (
            <div>
                <div>{capitalizeFirstLetter(discount?.name) || "N/A"}</div>
            </div>
        ),
        startDate: (
            <div>
                {new Date(discount.startDate).toLocaleDateString("en-GB")}
            </div>
        ),
        endDate: (
            <div>
                {new Date(discount.endDate).toLocaleDateString("en-GB")}
            </div>
        ),
        status: (
            <div
                style={{
                    backgroundColor: getStatusColorDiscount(discount?.status),
                    color: getStatusDiscountTextColor(discount?.status),
                }}
                className="rounded-full px-2 py-1 text-sm"
            >
                {capitalizeFirstLetter(discount.status)}
            </div>
        ),
    }));
    

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchQuery(e.target.value);
    };
    
    const handleCustomerFilterChange = (selectedValue: string) => {
        setSelectedType(selectedValue);
    };

    return (
        <div className="py-3 bg-white rounded-3xl shadow border border-[#C9C9C9] mt-10 pt-5">
            <div className="md:flex justify-between px-5">
                <p className="text-[20px] font-bold">Promo and Discount</p>
                <div className="md:flex gap-2 items-center md:mt-0 mt-2">
                    <Input
                        name="search"
                        value={searchQuery}
                        onChange={handleSearchChange}
                        className="w-full"
                        placeholder="Search"
                        icon="searchIcon"
                    />

                    <FIlterSelect
                        name="filter"
                        options={[
                        { value: "active", label: "Active" },
                        { value: "inactive", label: "InActive" },
                        { value: "pending", label: "Pending Approval" },
                        ]}
                        className="mt-2 md:mt-0 w-full md:w-[50%]"
                        icon="filterIcon"
                        onChange={handleCustomerFilterChange}
                        value={selectedType}
                    />
                </div>
            </div>

            {combinedData?.length > 0 ? (
                <Table
                columns={columns}
                data={combinedData}
                selectedUserId={null}
                onUserClick={handleUserClick}
                />
            ) : (
                <div className="opacity-80 mt-10 font-bold text-center mx-auto">
                No Discount found
                </div>
            )}
        </div>
    )

};

export default DiscountTable